// Get base URL for images
const getBaseUrl = () => {
  // Explicit env var always wins (used in production builds)
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL.replace('/api', '');
  }

  // Dev fallback: React dev server runs on :3000, backend on :5000.
  // window.location.origin would incorrectly point at :3000.
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return 'https://kid-o.ge';
  }

  return window.location.origin;
};

export const getImageUrl = (imagePath) => {
  if (!imagePath) return null;

  // If already a full URL, return as-is
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }

  const base = getBaseUrl();

  // Ensure exactly one slash between base and path
  const normalizedPath = imagePath.startsWith('/') ? imagePath : `/${imagePath}`;

  return `${base}${normalizedPath}`;
};

export default getImageUrl;
